import {
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  HStack,
  Icon,
  IconButton,
  Image,
  Text,
  VStack,
  useDisclosure,
} from "@chakra-ui/react";
import { List } from "@phosphor-icons/react";
import React from "react";
import { Link } from "react-router-dom";

export default function NavDrawer() {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <IconButton
        aria-label="navDrawer"
        icon={<Icon as={List} fontSize={24} />}
        className="btn"
        onClick={onOpen}
      />

      <Drawer isOpen={isOpen} onClose={onClose}>
        <DrawerOverlay />

        <DrawerContent>
          <DrawerCloseButton className="btn" color={"white"} />
          <DrawerBody p={0}>
            <VStack bg={"p.600"} h={"100vh"} p={8} align={"flex-start"}>
              <HStack gap={2} flexShrink={0} mb={8}>
                <Image src="/images/logo.png" h={"50px"} />
                <Box color={"white"}>
                  <Text fontWeight={800} lineHeight={1.4}>
                    KUBU
                  </Text>
                  <Text fontWeight={800} lineHeight={1.4}>
                    COURSE
                  </Text>
                </Box>
              </HStack>

              <VStack w={"100%"} align={"stretch"}>
                <Link to={"https://kubu.id"}>
                  <Button
                    className="btn"
                    color={"white"}
                    textAlign={"left"}
                    justifyContent={"space-between"}
                    w={"100%"}
                  >
                    Kubu.id
                  </Button>
                </Link>

                <Link to={"/"}>
                  <Button
                    className="btn"
                    color={"white"}
                    textAlign={"left"}
                    justifyContent={"space-between"}
                    w={"100%"}
                  >
                    Beranda
                  </Button>
                </Link>

                <Link to={"/allcourses"}>
                  <Button
                    className="btn"
                    color={"white"}
                    textAlign={"left"}
                    justifyContent={"space-between"}
                    w={"100%"}
                  >
                    Semua Course
                  </Button>
                </Link>
              </VStack>
            </VStack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
}
